var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternBatchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 83.864 83.864",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.032,41.717c1.413,0.66,2.982,1.041,4.646,1.041c6.074,0,10.996-4.923,10.996-10.997 c0-6.074-4.922-10.996-10.996-10.996c-6.018,0-10.896,4.834-10.988,10.829C53.157,33.767,55.586,37.446,56.032,41.717z",
    fill: "#696cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.342,43.508h-9.259c-0.101,3.705-1.681,7.041-4.182,9.438c6.901,2.053,11.948,8.452,11.948,16.011v3.518 c9.143-0.336,14.41-2.926,14.758-3.102l0.734-0.374h0.078V57.586C79.421,49.823,73.106,43.508,65.342,43.508z",
    fill: "#c3c4ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.486,
    cy: 43.113,
    r: 10.997,
    fill: "#696cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.149,54.859H37.82c-7.764,0-14.08,6.317-14.08,14.08v11.413l0.029,0.179l0.785,0.246 c7.409,2.314,13.847,3.087,19.145,3.087c10.348,0,16.347-2.951,16.717-3.139l0.735-0.373h0.078V68.939 C61.229,61.177,54.912,54.859,47.149,54.859z",
    fill: "#c3c4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.844,20.082c3.723-1.699,8.131-1.705,11.941,0.273c1.329-0.815,2.511-1.917,3.425-3.306 c3.343-5.073,1.94-11.891-3.13-15.233C62.01-1.526,55.19-0.125,51.848,4.947C48.537,9.972,49.889,16.706,54.844,20.082z",
    fill: "#696cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.189,42.758c2.151,0,4.151-0.628,5.848-1.698c0.539-3.516,2.424-6.588,5.116-8.68c0.011-0.206,0.03-0.41,0.03-0.618 c0-6.074-4.924-10.996-10.994-10.996c-6.075,0-10.997,4.922-10.997,10.996C12.192,37.834,17.115,42.758,23.189,42.758z",
    fill: "#696cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.065,52.946c-2.489-2.386-4.065-5.705-4.18-9.388c-0.344-0.025-0.684-0.052-1.033-0.052h-9.329 c-7.765,0-14.08,6.315-14.08,14.078v11.413l0.028,0.179l0.787,0.247c5.943,1.856,11.248,2.711,15.855,2.979v-3.446 C21.115,61.398,26.163,54.999,33.065,52.946z",
    fill: "#c3c4ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.351,20.082c3.722-1.699,8.131-1.705,11.941,0.273c1.328-0.815,2.51-1.917,3.425-3.306 c3.343-5.073,1.94-11.891-3.13-15.233c-5.072-3.342-11.891-1.941-15.233,3.131C11.042,9.972,12.395,16.706,17.351,20.082z",
    fill: "#696cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.579,30.347L48.67,1.262H34.962l1.092,29.085H47.579z M47.579,2.313l-1.012,26.982h-9.5L36.056,2.313H47.579z",
    fill: "#696cff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternBatchIcon);
export default __webpack_public_path__ + "static/media/intern-batch-icon.d8d1af3f93aec4e56e85b91a273473d7.svg";
export { ForwardRef as ReactComponent };